import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IAppGlobalState {
  isSidebarCollapsed: boolean;
  districtId: string | null; // Added new state for districtId
}

const initialState: IAppGlobalState = {
  isSidebarCollapsed: false,
  districtId: null, // Initialized districtId
};

export const appGlobalSlice = createSlice({
  name: 'app-global',
  initialState,
  reducers: {
    setSidebarCollapsed: (state, action: PayloadAction<boolean>) => {
      state.isSidebarCollapsed = action.payload;
    },
    setDistrictId: (state, action: PayloadAction<string>) => {
      state.districtId = action.payload;
    },
  },
});

export const { setSidebarCollapsed, setDistrictId } = appGlobalSlice.actions;
export default appGlobalSlice.reducer;
